import Utils from "../utils/utils"

export class LearningObject {
    // TODO create models for all the arrays
    public id: number
    public title: string
    public description: string
    public duration: string
    public gradeRanges: string
    public grades: string[] = []
    public mediaType: string[] = []
    public posterImage: string
    public posterImages: any[] = []
    public posterImageUrl: string
    public searchDisplayImage: string
    public type: string
    public uri: string
    public languages: string[] = []
    public canonicalUrl: string
    public brand: string
    public subject: any
    public supportMaterials: string[] = []
    public resourcesCount: string
    public additionalFeatures: string[] = []
    public project: any
    public isCollection: boolean
    public routerLink: string[]

    public constructor(input: object, isCollection = false) {
        if (input) {
            Object.keys(input).map((key) => {
                const property = Utils.convertToCamelcase(key)
                this[property] = input[key]
            })
        }
        this.isCollection = this.mediaType.indexOf("Collection") >= 0 || isCollection
        this.escapePosterImageUrls()
        this.routerLink = this.getRouterLink(this.isCollection)
    }

    public hasSupportMaterials() {
        // TODO: make an enum for this string and others like this in this file and in app in general
        if (this.additionalFeatures.indexOf("Support Materials") !== -1) {
            return true
        }
        return this.supportMaterials.length > 0
    }

    public getPosterImage(width?: number, height?: number, type?: string) {
        let url
        if (type) {
            url = this.getPosterImageIfExists(type, width, height)
            if (url) {
                return url
            }
        }
        url = this.getPosterImageIfExists("original", width, height)
        if (url) {
            return url
        }
        url = this.getPosterImageIfExists("default", width, height)
        if (url) {
            return url
        }
        if (this.posterImage) {
            return this.posterImage
        }
        return null
    }

    public getPosterImageIfExists(type: string, width?: number, height?: number) {
        return Utils.getITSImageIfExists(this.posterImages, type, width, height)
    }

    public getPosterImageAlt(type?: string) {
        if (!this.posterImages) {
            return this.title
        }
        if (type) {
            const posterImage = this.posterImages.find((image) => image.type === type)
            if (posterImage) {
                return posterImage.alt_text
            }
        }
        if (this.posterImages && this.posterImages.length > 0) {
            return this.posterImages[0].alt_text
        }
        return this.title
    }

    private getRouterLink(isCollection: boolean) {
        const canonicalURLParts = (this.canonicalUrl || "").split("/").filter((p) => p.length)
        if (canonicalURLParts.length < 2) {
            return ["/"]
        }
        if (isCollection) {
            const slugsPart = (this.canonicalUrl || "").split("/collection/").slice(-1)[0]
            const slugs = slugsPart.split("/").filter((p) => p.length)
            return ["/", "collection"].concat(slugs)
        }

        const resourceURLParts = canonicalURLParts.slice(canonicalURLParts.indexOf("resource") + 1)
        return ["/", "resource"].concat(resourceURLParts)
    }

    private escapePosterImageUrls() {
        this.posterImage = Utils.escapePosterImage(this.posterImage)
        this.posterImages = Utils.escapePosterImage(this.posterImages)
        this.posterImageUrl = Utils.escapePosterImage(this.posterImageUrl)
        this.searchDisplayImage = Utils.escapePosterImage(this.searchDisplayImage)
    }
}
